"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncStringify = exports.possiblyAsyncStringify = exports.stringify = exports.stringifyInternal = exports.hasAsyncToStringMethod = exports.asyncToStringMethod = exports.hasToStringMethod = exports.toStringMethod = void 0;
exports.toStringMethod = Symbol('fast-check/toStringMethod');

function hasToStringMethod(instance) {
  return instance !== null && (typeof instance === 'object' || typeof instance === 'function') && exports.toStringMethod in instance && typeof instance[exports.toStringMethod] === 'function';
}

exports.hasToStringMethod = hasToStringMethod;
exports.asyncToStringMethod = Symbol('fast-check/asyncToStringMethod');

function hasAsyncToStringMethod(instance) {
  return instance !== null && (typeof instance === 'object' || typeof instance === 'function') && exports.asyncToStringMethod in instance && typeof instance[exports.asyncToStringMethod] === 'function';
}

exports.hasAsyncToStringMethod = hasAsyncToStringMethod;
var findSymbolNameRegex = /^Symbol\((.*)\)$/;

function getSymbolDescription(s) {
  if (s.description !== undefined) return s.description;
  var m = findSymbolNameRegex.exec(String(s));
  return m && m[1].length ? m[1] : null;
}

function stringifyNumber(numValue) {
  switch (numValue) {
    case 0:
      return 1 / numValue === Number.NEGATIVE_INFINITY ? '-0' : '0';

    case Number.NEGATIVE_INFINITY:
      return 'Number.NEGATIVE_INFINITY';

    case Number.POSITIVE_INFINITY:
      return 'Number.POSITIVE_INFINITY';

    default:
      return numValue === numValue ? String(numValue) : 'Number.NaN';
  }
}

function isSparseArray(arr) {
  var previousNumberedIndex = -1;

  for (var index in arr) {
    var numberedIndex = Number(index);
    if (numberedIndex !== previousNumberedIndex + 1) return true;
    previousNumberedIndex = numberedIndex;
  }

  return previousNumberedIndex + 1 !== arr.length;
}

function stringifyInternal(value, previousValues, getAsyncContent) {
  var currentValues = previousValues.concat([value]);

  if (typeof value === 'object') {
    if (previousValues.indexOf(value) !== -1) {
      return '[cyclic]';
    }
  }

  if (hasAsyncToStringMethod(value)) {
    var content = getAsyncContent(value);

    if (content.state === 'fulfilled') {
      return content.value;
    }
  }

  if (hasToStringMethod(value)) {
    try {
      return value[exports.toStringMethod]();
    } catch (err) {}
  }

  switch (Object.prototype.toString.call(value)) {
    case '[object Array]':
      {
        var arr = value;

        if (arr.length >= 50 && isSparseArray(arr)) {
          var assignments = [];

          for (var index in arr) {
            if (!Number.isNaN(Number(index))) assignments.push("".concat(index, ":").concat(stringifyInternal(arr[index], currentValues, getAsyncContent)));
          }

          return assignments.length !== 0 ? "Object.assign(Array(".concat(arr.length, "),{").concat(assignments.join(','), "})") : "Array(".concat(arr.length, ")");
        }

        var stringifiedArray = arr.map(function (v) {
          return stringifyInternal(v, currentValues, getAsyncContent);
        }).join(',');
        return arr.length === 0 || arr.length - 1 in arr ? "[".concat(stringifiedArray, "]") : "[".concat(stringifiedArray, ",]");
      }

    case '[object BigInt]':
      return "".concat(value, "n");

    case '[object Boolean]':
      return typeof value === 'boolean' ? JSON.stringify(value) : "new Boolean(".concat(JSON.stringify(value), ")");

    case '[object Date]':
      {
        var d = value;
        return Number.isNaN(d.getTime()) ? "new Date(NaN)" : "new Date(".concat(JSON.stringify(d.toISOString()), ")");
      }

    case '[object Map]':
      return "new Map(".concat(stringifyInternal(Array.from(value), currentValues, getAsyncContent), ")");

    case '[object Null]':
      return "null";

    case '[object Number]':
      return typeof value === 'number' ? stringifyNumber(value) : "new Number(".concat(stringifyNumber(Number(value)), ")");

    case '[object Object]':
      {
        try {
          var toStringAccessor = value.toString;

          if (typeof toStringAccessor === 'function' && toStringAccessor !== Object.prototype.toString) {
            return value.toString();
          }
        } catch (err) {
          return '[object Object]';
        }

        var mapper = function mapper(k) {
          return "".concat(k === '__proto__' ? '["__proto__"]' : typeof k === 'symbol' ? "[".concat(stringifyInternal(k, currentValues, getAsyncContent), "]") : JSON.stringify(k), ":").concat(stringifyInternal(value[k], currentValues, getAsyncContent));
        };

        var stringifiedProperties = [].concat(_toConsumableArray(Object.keys(value).map(mapper)), _toConsumableArray(Object.getOwnPropertySymbols(value).filter(function (s) {
          var descriptor = Object.getOwnPropertyDescriptor(value, s);
          return descriptor && descriptor.enumerable;
        }).map(mapper)));
        var rawRepr = '{' + stringifiedProperties.join(',') + '}';

        if (Object.getPrototypeOf(value) === null) {
          return rawRepr === '{}' ? 'Object.create(null)' : "Object.assign(Object.create(null),".concat(rawRepr, ")");
        }

        return rawRepr;
      }

    case '[object Set]':
      return "new Set(".concat(stringifyInternal(Array.from(value), currentValues, getAsyncContent), ")");

    case '[object String]':
      return typeof value === 'string' ? JSON.stringify(value) : "new String(".concat(JSON.stringify(value), ")");

    case '[object Symbol]':
      {
        var s = value;

        if (Symbol.keyFor(s) !== undefined) {
          return "Symbol.for(".concat(JSON.stringify(Symbol.keyFor(s)), ")");
        }

        var desc = getSymbolDescription(s);

        if (desc === null) {
          return 'Symbol()';
        }

        var knownSymbol = desc.startsWith('Symbol.') && Symbol[desc.substring(7)];
        return s === knownSymbol ? desc : "Symbol(".concat(JSON.stringify(desc), ")");
      }

    case '[object Promise]':
      {
        var promiseContent = getAsyncContent(value);

        switch (promiseContent.state) {
          case 'fulfilled':
            return "Promise.resolve(".concat(stringifyInternal(promiseContent.value, currentValues, getAsyncContent), ")");

          case 'rejected':
            return "Promise.reject(".concat(stringifyInternal(promiseContent.value, currentValues, getAsyncContent), ")");

          case 'pending':
            return "new Promise(() => {/*pending*/})";

          case 'unknown':
          default:
            return "new Promise(() => {/*unknown*/})";
        }
      }

    case '[object Error]':
      if (value instanceof Error) {
        return "new Error(".concat(stringifyInternal(value.message, currentValues, getAsyncContent), ")");
      }

      break;

    case '[object Undefined]':
      return "undefined";

    case '[object Int8Array]':
    case '[object Uint8Array]':
    case '[object Uint8ClampedArray]':
    case '[object Int16Array]':
    case '[object Uint16Array]':
    case '[object Int32Array]':
    case '[object Uint32Array]':
    case '[object Float32Array]':
    case '[object Float64Array]':
    case '[object BigInt64Array]':
    case '[object BigUint64Array]':
      {
        if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(value)) {
          return "Buffer.from(".concat(stringifyInternal(Array.from(value.values()), currentValues, getAsyncContent), ")");
        }

        var valuePrototype = Object.getPrototypeOf(value);
        var className = valuePrototype && valuePrototype.constructor && valuePrototype.constructor.name;

        if (typeof className === 'string') {
          var typedArray = value;
          var valuesFromTypedArr = typedArray.values();
          return "".concat(className, ".from(").concat(stringifyInternal(Array.from(valuesFromTypedArr), currentValues, getAsyncContent), ")");
        }

        break;
      }
  }

  try {
    return value.toString();
  } catch (_a) {
    return Object.prototype.toString.call(value);
  }
}

exports.stringifyInternal = stringifyInternal;

function stringify(value) {
  return stringifyInternal(value, [], function () {
    return {
      state: 'unknown',
      value: undefined
    };
  });
}

exports.stringify = stringify;

function possiblyAsyncStringify(value) {
  var stillPendingMarker = Symbol();
  var pendingPromisesForCache = [];
  var cache = new Map();

  function createDelay0() {
    var handleId = null;

    var cancel = function cancel() {
      if (handleId !== null) {
        clearTimeout(handleId);
      }
    };

    var delay = new Promise(function (resolve) {
      handleId = setTimeout(function () {
        handleId = null;
        resolve(stillPendingMarker);
      }, 0);
    });
    return {
      delay: delay,
      cancel: cancel
    };
  }

  var unknownState = {
    state: 'unknown',
    value: undefined
  };

  var getAsyncContent = function getAsyncContent(data) {
    var cacheKey = data;

    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }

    var delay0 = createDelay0();
    var p = exports.asyncToStringMethod in data ? Promise.resolve().then(function () {
      return data[exports.asyncToStringMethod]();
    }) : data;
    p.catch(function () {});
    pendingPromisesForCache.push(Promise.race([p, delay0.delay]).then(function (successValue) {
      if (successValue === stillPendingMarker) cache.set(cacheKey, {
        state: 'pending',
        value: undefined
      });else cache.set(cacheKey, {
        state: 'fulfilled',
        value: successValue
      });
      delay0.cancel();
    }, function (errorValue) {
      cache.set(cacheKey, {
        state: 'rejected',
        value: errorValue
      });
      delay0.cancel();
    }));
    cache.set(cacheKey, unknownState);
    return unknownState;
  };

  function loop() {
    var stringifiedValue = stringifyInternal(value, [], getAsyncContent);

    if (pendingPromisesForCache.length === 0) {
      return stringifiedValue;
    }

    return Promise.all(pendingPromisesForCache.splice(0)).then(loop);
  }

  return loop();
}

exports.possiblyAsyncStringify = possiblyAsyncStringify;

function asyncStringify(_x) {
  return _asyncStringify.apply(this, arguments);
}

function _asyncStringify() {
  _asyncStringify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve(possiblyAsyncStringify(value)));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncStringify.apply(this, arguments);
}

exports.asyncStringify = asyncStringify;